import { DefaultBrandColors, ITheme } from '../models';

/**
 * Query params the hosted Keycloak SSO login template reads to white-label the
 * login page — the single contract shared by the web (KeycloakService) and
 * NativeScript (AuthNSService) clients. Params without a value are skipped.
 *
 * `isResident` is always sent: it switches the template's resident branch,
 * which renders the "Forgot password" link as the resident reset entry
 * (`<redirect_uri origin>/request-reset-password` for http(s) clients, an
 * OAuth error-callback URL with `error_description=password_reset_requested`
 * for custom-scheme mobile clients) instead of the legacy tenant reset page.
 * The mobile app intercepts that link in its OAuth webview (see ART-19562).
 */
export const getSsoBrandingParams = (theme: ITheme | null | undefined): Record<string, string> => {
  const brandingParams: Record<string, string | undefined> = {
    isResident: 'true',
    primaryColor: theme?.colorPrimary ?? DefaultBrandColors.PRIMARY,
    backgroundColor: theme?.colorBackgroundLight,
    containerColor: theme?.colorSurface,
    primaryTextColor: theme?.colorTextPrimary,
    secondaryTextColor: theme?.colorTextSecondary,
  };
  const params: Record<string, string> = {};
  for (const [key, value] of Object.entries(brandingParams)) {
    if (value) {
      params[key] = value;
    }
  }
  return params;
};
